import { api } from './api';

export const useOneSiteProspectPageUrl = (prospectId: number) => {
  const { useGetOneSiteProspectPageUrlQuery } = api;
  const { data, error, isFetching } =
    useGetOneSiteProspectPageUrlQuery(prospectId);

  return { url: data || '', error, loadingUrl: isFetching };
};
